import React from 'react';
import { useNavigate } from "react-router-dom";
import { MyMLink, MyMBlackLink } from '../ui-elements/MyMLink';

export const NavigateLink = (props) => {
  const navigate = useNavigate();
  const { isBlackTheme, navigateState, to, newTabNavigate, navigateCallback, ...other } = props;

  const clickAction = () => {
    if (newTabNavigate) {
      window.open(`${process.env.PUBLIC_URL}${to}`, '_blank');
    } else {
      navigate(to, navigateState);
    }

    navigateCallback && navigateCallback();
  }

  return (isBlackTheme ?
    <MyMBlackLink onClick={clickAction} {...other} /> :
    <MyMLink      onClick={clickAction} {...other} />
  )
}

